import { render, staticRenderFns } from "./recallModal.vue?vue&type=template&id=fd7216d8&scoped=true"
import script from "./recallModal.vue?vue&type=script&lang=js"
export * from "./recallModal.vue?vue&type=script&lang=js"
import style0 from "./recallModal.vue?vue&type=style&index=0&id=fd7216d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd7216d8",
  null
  
)

export default component.exports